import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="arrows">
        <path
          id="Triangle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 0.5L8 3.5H0L4 0.5Z"
          fill="#BFBFB3"
        />
        <path
          id="Triangle_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 8.5L8 5.5H0L4 8.5Z"
          fill="#BFBFB3"
        />
      </g>
    </Svg>
  );
};

export default Icon;
